<template>
  <d-container fluid class="auth main-content-container align-items-center justify-content-center">
    <d-col md="8" class="text-center">
      <div v-if="d_request.loading && !d_request.error">
        <loader :loading="d_request.loading" />
      </div>

      <div v-else-if="d_request.error">
        {{ $t('error.general') }}: {{ d_request.errors.get('message') }}
      </div>
    </d-col>
  </d-container>
</template>

<script>
import RedirectRequest from '@/library/RedirectRequest';

export default {
  name: 'auth-social',
  data () {
    return {
      d_request: new RedirectRequest(),
    };
  },
  created () {
    const url = this.$route.fullPath;

    this.d_request.post(url);
  },
}
</script>
